import { getUserConfiguration } from 'owa-session-store';
import { owaDate, OwaDate } from 'owa-datetime';

export function getOwaDateFromDateString(stringDate: string): OwaDate {
    const endDate = new Date(stringDate);
    return owaDate(
        getUserConfiguration().UserOptions.TimeZone,
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate()
    );
}
